import { Box, Text } from 'ink';
import { useEffect } from 'react';
import CliError from '../utilities/CliError';
import getCliVersion from '../utilities/getCliVersion';
import logger from '../utilities/logger';
import useExit from '../utilities/useExit';

const shouldShowVerboseDiagnostics = process.env.TODESKTOP_DEBUG === '1';

export default function ErrorDisplay({
  commandUsed,
  error,
}: {
  commandUsed?: string;
  error?: unknown;
}) {
  const exit = useExit();

  const normalizedError = CliError.from(error);

  logger.error({ error });

  // After an error is set, exit
  useEffect(() => {
    if (!error) {
      return;
    }
    // Just to avoid updating state after exiting the React app
    setTimeout(() => exit(normalizedError), 10);
  }, [exit, error, normalizedError]);

  return (
    <>
      <Text backgroundColor="red" color="white">
        {' '}
        ERROR{' '}
      </Text>
      <Text>{normalizedError.message}</Text>

      <Box flexDirection="column" marginTop={1}>
        {commandUsed ? (
          <Text dimColor color="gray">
            Command: {commandUsed}
          </Text>
        ) : null}
        <Text dimColor color="gray">
          @todesktop/cli: {getCliVersion()}
        </Text>
        {shouldShowVerboseDiagnostics ? (
          <Text dimColor color="gray">
            Node: {process.version}
          </Text>
        ) : null}
        {shouldShowVerboseDiagnostics ? (
          <Text dimColor color="gray">
            cwd: {process.cwd()}
          </Text>
        ) : null}
      </Box>
    </>
  );
}
